/*************************************************/
/* ACCORDION-IMAGES                              */
/*************************************************/
import customEventsNames from '../customEventsNames';

export function cardAccordionImages() {

    const accordionImagesContainerSelector = ".card-accordion__media-container";
    const accordionImageSelector = ".card-accordion__media";
    const accordionImageActiveClass = "card-accordion__media--active";
    const accordionImageFallbackClass = "card-accordion__media--fallback";
    const defaultItemIndex = 1; // The index of the default item

    const init = () => {
        const imageContainers = document.querySelectorAll(accordionImagesContainerSelector);
        if (imageContainers) {
            imageContainers.forEach(container => {


                // Select both the default and fallback images
                const images = container.querySelectorAll(accordionImageSelector);

                if (images[defaultItemIndex].classList.contains(accordionImageActiveClass)) {
                    images[0].classList.remove(accordionImageActiveClass);
                }

                container.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    let i = 0;
                    container.querySelectorAll(accordionImageSelector).forEach(image => {
                        image.classList.remove(accordionImageActiveClass);
                        if (image.classList.contains(accordionImageFallbackClass)) return;
                        if (i == e.detail.accordionItemIndex) {
                            image.classList.add(accordionImageActiveClass);
                        }
                        i++;
                    });
                });
            });
        }
    };

    init();
}

export function accordionImages() {

    const accordionImagesContainerSelector = ".image-accordion__media-container";
    const accordionImageSelector = ".image-accordion__media";
    const accordionImageActiveClass = "image-accordion__media--active";
    const accordionImageFallbackClass = "image-accordion__media--fallback";
    const defaultItemIndex = 1; // The index of the default item

    const init = () => {
        const imageContainers = document.querySelectorAll(accordionImagesContainerSelector);
        if (imageContainers) {
            imageContainers.forEach(container => {


                // Select both the default and fallback images
                const images = container.querySelectorAll(accordionImageSelector);

                if (images[defaultItemIndex].classList.contains(accordionImageActiveClass)) {
                    images[0].classList.remove(accordionImageActiveClass);
                }

                container.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    let i = 0;
                    container.querySelectorAll(accordionImageSelector).forEach(image => {
                        image.classList.remove(accordionImageActiveClass);
                        if (image.classList.contains(accordionImageFallbackClass)) return;
                        if (i == e.detail.accordionItemIndex) {
                            image.classList.add(accordionImageActiveClass);
                        }
                        i++;
                    });
                });
            });
        }
    };

    init();
}